import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ABN, ADDRESS, EMAIL, EMAIL_HREF, HOURS, LEGAL_NAME, PHONE_DISPLAY, PHONE_TEL } from './shared';
import { BrandLogo } from './BrandLogo';
const columns = [{
  heading: 'Claims',
  links: [{
    label: "Workers' compensation",
    href: '/workers-compensation-lawyers-perth/'
  }, {
    label: 'Road accidents',
    href: '/car-accident-lawyers-perth/'
  }, {
    label: 'Public liability',
    href: '/public-liability-lawyers-perth/'
  }, {
    label: 'Catastrophic injury',
    href: '/catastrophic-injury-lawyers-perth/'
  }]
}, {
  heading: 'Firm',
  links: [{
    label: 'Our team',
    href: '/our-team/'
  }, {
    label: 'Fees explained',
    href: '#fees'
  }, {
    label: 'About',
    href: '/about/'
  }]
}, {
  heading: 'Resources',
  links: [{
    label: 'Guides',
    href: '/resources/guides/'
  }, {
    label: 'FAQs',
    href: '/resources/faqs/'
  }, {
    label: 'Client reviews',
    href: '#reviews'
  }, {
    label: 'Contact',
    href: '/contact/'
  }]
}];
export function Footer() {
  return <footer className="w-full bg-ink text-paper" data-id="element-247" data-mp="3gbiliokp7i08">
      <div className="mx-auto w-full max-w-7xl px-5 py-10 sm:px-6 lg:px-8" data-id="element-248" data-mp="3gctr8txpeztz">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-[1.35fr_1fr_1fr_1fr] lg:gap-10" data-id="element-249" data-mp="3v91b1t579z8q">
          <div data-id="element-250" data-mp="3qaq17iewnoqi">
            <BrandLogo inverse data-id="element-251" data-mp="830knmyxgd2l" />
            <p className="mt-5 max-w-sm text-[15px] leading-[1.6] text-stone/70" data-id="element-252" data-mp="828mc4dy418m">
              Established Perth personal injury lawyers providing clear advice
              and strong representation since 1990.
            </p>
          </div>

          {columns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-253" data-mp="ct75rcu8dfg3">
              <h3 className="text-small font-semibold uppercase tracking-wider text-stone/60" data-id="element-254" data-mp="cw33p162w44j">
                {column.heading}
              </h3>
              <ul className="mt-4 space-y-2.5" data-id="element-255" data-mp="mspqhvhyt597">
                {column.links.map(link => <li key={link.label} data-id="element-256" data-mp="tvw8ij57pjh1">
                    <a href={link.href} className="rounded text-body text-stone/80 transition-colors duration-150 ease-out hover:text-gold-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light" data-id="element-257" data-mp="twxrd9sgza9b">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-9 grid grid-cols-1 overflow-hidden rounded-card border border-stone/15 bg-paper/[0.04] sm:grid-cols-2 lg:grid-cols-[0.85fr_1.65fr_1.45fr_1fr_auto]" data-id="element-258" data-mp="1hk5vvpi2qfaa">
          <a href={PHONE_TEL} className="flex min-h-[64px] items-center gap-3 border-b border-stone/15 px-4 text-[15px] font-semibold text-paper transition-colors duration-150 ease-out hover:bg-paper/[0.06] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light sm:border-r lg:border-b-0" data-id="element-259" data-mp="1riv40qk64ldc">
            <PhoneIcon className="h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-260" data-mp="2afx1uxtgg54x" />
            {PHONE_DISPLAY}
          </a>
          <a href={EMAIL_HREF} className="flex min-h-[64px] items-center gap-2.5 border-b border-stone/15 px-4 text-[13px] text-paper transition-colors duration-150 ease-out hover:bg-paper/[0.06] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light lg:border-b-0 lg:border-r" data-id="element-261" data-mp="25mapz7v485a6">
            <MailIcon className="h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-262" data-mp="2pbuwgbnqd1f1" />
            <span className="whitespace-nowrap" data-id="element-263" data-mp="2kd1fg998isa4">{EMAIL}</span>
          </a>
          <span className="flex min-h-[64px] items-center gap-3 border-b border-stone/15 px-4 text-[14px] leading-[1.45] text-stone/75 sm:border-r lg:border-b-0" data-id="element-264" data-mp="2kf4e1hogdtqg">
            <MapPinIcon className="h-4 w-4 shrink-0 text-gold-light" aria-hidden="true" data-id="element-265" data-mp="18yxlv46k765l" />
            {ADDRESS}
          </span>
          <span className="flex min-h-[64px] items-center px-4 text-[13px] leading-[1.45] text-stone/60" data-id="element-266" data-mp="1414ieiwn4q90">
            {HOURS}<br data-id="element-267" data-mp="2wmfygt723jdy" />ABN {ABN}
          </span>
          <a href="#compensation-calculator" className="flex min-h-[64px] items-center justify-center whitespace-nowrap bg-signal px-5 text-[14px] font-semibold text-paper transition-colors duration-150 ease-out hover:bg-signal-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light sm:col-span-2 lg:col-span-1" data-id="element-268" data-mp="2wnhl7uxfpubi">
            Start free claim check
          </a>
        </div>

        <div className="mt-9 border-t border-stone/15 pt-7" data-id="element-269" data-mp="3fj7p5noxh0s1">
          <p className="max-w-4xl text-small text-stone/55" data-id="element-270" data-mp="31khjvkryfusl">
            The information on this website is general in nature and is not legal
            advice. It does not take account of your individual circumstances.
            Time limits and eligibility for compensation claims vary. You should
            obtain advice specific to your situation before acting.
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-271" data-mp="1nl6aw2fqltp9">
            <p className="text-small text-stone/50" data-id="element-272" data-mp="1innw3vf1gk9c">
              © 2026 {LEGAL_NAME}
            </p>
            <ul className="flex flex-wrap gap-x-5 gap-y-2 text-small" data-id="element-273" data-mp="1wmvxmuyoc4gp">
              {[['Privacy policy', '/privacy/'], ['Terms', '/terms/'], ['Complaints', '/complaints/'], ['Sitemap', '/sitemap.xml']].map(([label, href]) => <li key={label} data-id="element-274" data-mp="zxocho1yvxdb">
                  <a href={href} className="text-stone/70 transition-colors duration-150 ease-out hover:text-gold-light" data-id="element-275" data-mp="zuacgmgs0091">
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </footer>;
}